// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monitoring-container {
    padding: 0 5px;
    max-width: 100%;
    margin: 0;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }
  
  .monitoring-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
    flex-shrink: 0;
    height: 60px;
  }
  
  .header-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .header-left h2 {
    margin: 0;
    font-size: 1.1em;
    font-weight: 700;
    color: #2c3e50;
  }
  
  .last-update {
    font-size: 0.85em;
    color: #34495e;
    font-weight: 500;
  }
  
  .header-controls {
    display: flex;
    align-items: center;
    gap: 15px;
    height: 100%;
  }
  
  .page-info {
    font-weight: 700;
    color: #2c3e50;
    background-color: #ecf0f1;
    padding: 5px 10px;
    border-radius: 15px;
    font-size: 0.9em;
  }
  
  .control-buttons {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .nav-button {
    background-color: #6c7b8a;
    color: #ffffff;
    border: none;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
  }
  
  .nav-button:hover {
    background-color: #5a6b7a;
    transform: scale(1.05);
  }
  
  .interval-setting {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  
  .interval-input {
    width: 50px;
    padding: 4px 6px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 12px;
    text-align: center;
  }
  
  .interval-label {
    font-size: 12px;
    color: #2c3e50;
    font-weight: 600;
  }
  
  .auto-button {
    background-color: #6c7b8a;
    color: #ffffff;
    border: none;
    border-radius: 16px;
    padding: 6px 12px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.2s ease;
  }
  
  .auto-button.active {
    background-color: #5a8a6c;
  }
  
  .auto-button:hover {
    background-color: #5a6b7a;
  }
  
  .fullscreen-button {
    background-color: #27ae60;
    color: #ffffff;
    border: none;
    border-radius: 16px;
    padding: 6px 12px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.2s ease;
    margin-right: 8px;
  }
  
  .fullscreen-button:hover {
    background-color: #229954;
  }
  
  .refresh-button {
    background-color: #6c7b8a;
    color: #ffffff;
    border: none;
    border-radius: 16px;
    padding: 6px 12px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.2s ease;
  }
  
  .refresh-button:hover {
    background-color: #5a6b7a;
  }
  
  .refresh-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  .monitoring-groups {
    display: grid;
    gap: 8px;
    height: calc(100vh - 100px);
    width: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  /* 페이지별 레이아웃 */
  .monitoring-groups.page-1 {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }

  .monitoring-groups.page-2 {
    grid-template-columns: 1fr 2fr !important;
    grid-template-rows: 1fr;
    overflow: hidden;
  }

  .monitoring-groups.page-3 {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr;
  }

  .monitoring-groups.page-4 {
    grid-template-columns: 2fr 1fr !important;
    grid-template-rows: 1fr;
    overflow: hidden;
  }

  .monitoring-groups.page-5 {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
  }
  
  /* 8개 센서 2개: 세로 배치 */
  .monitoring-groups:has(.group-8) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, 1fr);
  }
  
  /* 6개 센서 2개: 좌우 배치 */
  .monitoring-groups:has(.group-6):not(:has(.group-8)) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
  }
  
  /* 4개 센서 2개: 좌우 배치 */
  .monitoring-groups:has(.group-4) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
  }
  
  /* 3개 센서 4개: 가로 배치 */
  .monitoring-groups:has(.group-3) {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
  }
  
  /* 1개 센서: 나머지 */
  .monitoring-groups:has(.group-1):not(:has(.group-3, .group-4, .group-6, .group-8)) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-template-rows: repeat(auto-fit, 1fr);
  }
  
  .monitoring-group {
    background-color: #ffffff;
    border-radius: 4px;
    padding: 8px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
    border: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 120px;
  }
  
  /* 8개 센서: 전체 화면 차지 */
  .group-8 {
    grid-column: span 1;
    grid-row: span 1;
  }
  
  /* 6개 센서: 전체 화면 차지 */
  .group-6 {
    grid-column: span 1;
    grid-row: span 1;
  }
  
  /* 4개 센서: 좌우 배치 */
  .group-4 {
    grid-column: span 1;
    grid-row: span 1;
  }
  
  /* 3개 센서: 세로 배치 */
  .group-3 {
    grid-column: span 1;
    grid-row: span 1;
  }
  
  /* 1개 센서 */
  .group-1 {
    grid-column: span 1;
    grid-row: span 1;
  }
  
  .group-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
    padding-bottom: 4px;
    border-bottom: 1px solid #007bff;
    flex-shrink: 0;
  }
  
  .group-header h3 {
    margin: 0;
    color: #007bff;
    font-size: 1.4em;
    font-weight: 600;
  }
  
  .group-count {
    color: #666;
    font-size: 1em;
    background-color: #f5f5f5;
    padding: 3px 8px;
    border-radius: 12px;
  }
  
  .monitoring-grid {
    display: grid;
    gap: 12px;
    flex: 1 1;
    align-content: stretch;
    align-items: stretch;
    overflow: hidden;
    height: 100%;
    padding: 8px;
  }
  
  /* 8개: 8x1 (가로로 길게) */
  .grid-8 {
    grid-template-columns: repeat(8, 1fr);
    grid-template-rows: 1fr;
  }
  
  /* 6개: 3x2 */
  .grid-6 {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }
  
  /* 4개: 2x2 (좌우 배치용) */
  .grid-4 {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }
  
  /* 3개: 1x3 (vertical 배치) */
  .grid-3 {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
  }
  
  /* 1개: 1x1 */
  .grid-1 {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }
  
  .monitoring-box {
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 8px;
    text-align: center;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 60px;
    width: 100%;
    height: 100%;
    margin: 2px;
  }
  
  .monitoring-box.no-data {
    background-color: #ccc;
    color: #666;
  }
  
  .monitoring-box.normal,
  .monitoring-box.low-temp,
  .monitoring-box.high-temp,
  .monitoring-box.abnormal {
    color: white;
  }
  
  .monitoring-machine {
    font-size: 16px;
    margin-bottom: 6px;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    font-weight: 700;
    color: #2c3e50;
    text-shadow: 0 1px 1px rgba(0,0,0,0.1);
  }
  
  .monitoring-temp {
    font-size: 28px;
    margin-bottom: 6px;
    font-weight: 800;
    line-height: 1;
    color: #2c3e50;
    text-shadow: 0 1px 2px rgba(0,0,0,0.15);
  }
  
  .monitoring-range {
    font-size: 14px;
    line-height: 1.1;
    overflow: hidden;
    text-align: center;
    width: 100%;
    font-weight: 600;
    color: #34495e;
    text-shadow: 0 1px 1px rgba(0,0,0,0.1);
  }
  
  .monitoring-legend {
    display: flex;
    justify-content: center;
    gap: 15px;
    font-size: 14px;
    margin: 0;
    padding: 3px 0;
    flex-shrink: 0;
    height: 20px;
    align-items: center;
    background-color: var(--background-color);
  }
  
  @media (max-width: 768px) {
    .monitoring-container {
      padding: 0 2px;
    }
    
    .monitoring-groups {
      grid-template-columns: 1fr !important;
      grid-template-rows: 1fr !important;
      height: calc(100vh - 160px);
    }
    
    .monitoring-group {
      padding: 4px;
      grid-column: span 1 !important;
      grid-row: span 1 !important;
    }
    
    .monitoring-grid {
      grid-template-columns: repeat(auto-fit, minmax(35px, 1fr)) !important;
      gap: 2px;
    }
    
    .monitoring-legend {
      flex-wrap: wrap;
      gap: 6px;
      font-size: 11px;
    }
  }
  
  [data-theme="dark"] .monitoring-header {
    background-color: #2d2d2d;
    color: #ffffff;
  }
  
  [data-theme="dark"] .page-info {
    background-color: #34495e;
    color: #ecf0f1;
  }
  
  [data-theme="dark"] .header-left h2 {
    color: #ecf0f1;
  }
  
  [data-theme="dark"] .last-update {
    color: #bdc3c7;
  }
  
  [data-theme="dark"] .nav-button {
    background-color: #4a5a6a;
  }
  
  [data-theme="dark"] .nav-button:hover {
    background-color: #3a4a5a;
  }
  
  [data-theme="dark"] .interval-input {
    background-color: #2d2d2d;
    border-color: #555;
    color: #fff;
  }
  
  [data-theme="dark"] .interval-label {
    color: #bdc3c7;
  }
  
  [data-theme="dark"] .auto-button {
    background-color: #4a5a6a;
  }
  
  [data-theme="dark"] .auto-button.active {
    background-color: #3a6a4a;
  }
  
  [data-theme="dark"] .auto-button:hover {
    background-color: #3a4a5a;
  }
  
  [data-theme="dark"] .refresh-button {
    background-color: #4a5a6a;
  }
  
  [data-theme="dark"] .refresh-button:hover {
    background-color: #3a4a5a;
  }
  
  [data-theme="dark"] .monitoring-group {
    background-color: #2d2d2d;
    border-color: #404040;
    box-shadow: 0 1px 2px rgba(0,0,0,0.2);
  }
  
  [data-theme="dark"] .monitoring-box {
    background-color: #1a1a1a !important;
    border-color: #555;
  }
  
  [data-theme="dark"] .monitoring-box.no-data {
    background-color: #333 !important;
  }
  
  [data-theme="dark"] .monitoring-machine {
    color: #ecf0f1;
    text-shadow: 0 1px 1px rgba(0,0,0,0.3);
  }
  
  [data-theme="dark"] .monitoring-temp {
    color: #ecf0f1;
    text-shadow: 0 1px 2px rgba(0,0,0,0.4);
  }
  
  [data-theme="dark"] .monitoring-range {
    color: #bdc3c7;
    text-shadow: 0 1px 1px rgba(0,0,0,0.3);
  }
  
  [data-theme="dark"] .group-header h3 {
    color: #4b8bd4;
  }
  
  [data-theme="dark"] .group-count {
    background-color: #404040;
    color: #ccc;
  }

/* 뱃지 컨테이너 */
.badge-container {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  justify-content: center;
  flex-wrap: wrap;
}

/* 공통 뱃지 스타일 */
.count-badge,
.inactive-badge {
  display: inline-block;
  padding: 12px 0;
  border-radius: 15px;
  font-size: 24px;
  font-weight: 800;
  text-align: center;
  min-width: 80px;
}

/* 개수 뱃지 스타일 */
.count-badge {
  background: #725AC1;
  color: white;
  border: 1px solid #725AC1;
}

/* 비가동 뱃지 스타일 */
.inactive-badge {
  background: #e74c3c;
  color: white;
  border: 1px solid #c0392b;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.7; }
  100% { opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/components/MonitoringContainer.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;IACf,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,SAAS;IACT,UAAU;IACV,gBAAgB;EAClB;;EAEA,cAAc;EACd;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,yCAAyC;IACzC,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,kCAAkC;IAClC,uBAAuB;EACzB;;EAEA;IACE,yCAAyC;IACzC,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,uBAAuB;EACzB;;EAEA,oBAAoB;EACpB;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;;EAEA,oBAAoB;EACpB;IACE,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA,oBAAoB;EACpB;IACE,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA,oBAAoB;EACpB;IACE,qCAAqC;IACrC,uBAAuB;EACzB;;EAEA,eAAe;EACf;IACE,2DAA2D;IAC3D,yCAAyC;EAC3C;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,sCAAsC;IACtC,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,UAAU;EACV;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,SAAO;IACP,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,YAAY;EACd;;EAEA,qBAAqB;EACrB;IACE,qCAAqC;IACrC,uBAAuB;EACzB;;EAEA,YAAY;EACZ;IACE,qCAAqC;IACrC,kCAAkC;EACpC;;EAEA,qBAAqB;EACrB;IACE,qCAAqC;IACrC,kCAAkC;EACpC;;EAEA,0BAA0B;EAC1B;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;;EAEA,YAAY;EACZ;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;;;IAIE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,uCAAuC;EACzC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,SAAS;IACT,cAAc;IACd,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,qCAAqC;MACrC,kCAAkC;MAClC,2BAA2B;IAC7B;;IAEA;MACE,YAAY;MACZ,8BAA8B;MAC9B,2BAA2B;IAC7B;;IAEA;MACE,qEAAqE;MACrE,QAAQ;IACV;;IAEA;MACE,eAAe;MACf,QAAQ;MACR,eAAe;IACjB;EACF;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,qCAAqC;EACvC;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;AAEF,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA,cAAc;AACd;;EAEE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB","sourcesContent":[".monitoring-container {\r\n    padding: 0 5px;\r\n    max-width: 100%;\r\n    margin: 0;\r\n    height: 100vh;\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .monitoring-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 5px;\r\n    padding: 15px;\r\n    background-color: #f8f9fa;\r\n    border-radius: 8px;\r\n    flex-shrink: 0;\r\n    height: 60px;\r\n  }\r\n  \r\n  .header-left {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .header-left h2 {\r\n    margin: 0;\r\n    font-size: 1.1em;\r\n    font-weight: 700;\r\n    color: #2c3e50;\r\n  }\r\n  \r\n  .last-update {\r\n    font-size: 0.85em;\r\n    color: #34495e;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .header-controls {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 15px;\r\n    height: 100%;\r\n  }\r\n  \r\n  .page-info {\r\n    font-weight: 700;\r\n    color: #2c3e50;\r\n    background-color: #ecf0f1;\r\n    padding: 5px 10px;\r\n    border-radius: 15px;\r\n    font-size: 0.9em;\r\n  }\r\n  \r\n  .control-buttons {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n  }\r\n  \r\n  .nav-button {\r\n    background-color: #6c7b8a;\r\n    color: #ffffff;\r\n    border: none;\r\n    border-radius: 50%;\r\n    width: 35px;\r\n    height: 35px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: all 0.2s ease;\r\n  }\r\n  \r\n  .nav-button:hover {\r\n    background-color: #5a6b7a;\r\n    transform: scale(1.05);\r\n  }\r\n  \r\n  .interval-setting {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .interval-input {\r\n    width: 50px;\r\n    padding: 4px 6px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 12px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .interval-label {\r\n    font-size: 12px;\r\n    color: #2c3e50;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .auto-button {\r\n    background-color: #6c7b8a;\r\n    color: #ffffff;\r\n    border: none;\r\n    border-radius: 16px;\r\n    padding: 6px 12px;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    transition: all 0.2s ease;\r\n  }\r\n  \r\n  .auto-button.active {\r\n    background-color: #5a8a6c;\r\n  }\r\n  \r\n  .auto-button:hover {\r\n    background-color: #5a6b7a;\r\n  }\r\n  \r\n  .fullscreen-button {\r\n    background-color: #27ae60;\r\n    color: #ffffff;\r\n    border: none;\r\n    border-radius: 16px;\r\n    padding: 6px 12px;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    transition: all 0.2s ease;\r\n    margin-right: 8px;\r\n  }\r\n  \r\n  .fullscreen-button:hover {\r\n    background-color: #229954;\r\n  }\r\n  \r\n  .refresh-button {\r\n    background-color: #6c7b8a;\r\n    color: #ffffff;\r\n    border: none;\r\n    border-radius: 16px;\r\n    padding: 6px 12px;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    transition: all 0.2s ease;\r\n  }\r\n  \r\n  .refresh-button:hover {\r\n    background-color: #5a6b7a;\r\n  }\r\n  \r\n  .refresh-button:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  .monitoring-groups {\r\n    display: grid;\r\n    gap: 8px;\r\n    height: calc(100vh - 100px);\r\n    width: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    overflow: hidden;\r\n  }\r\n\r\n  /* 페이지별 레이아웃 */\r\n  .monitoring-groups.page-1 {\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: 1fr;\r\n  }\r\n\r\n  .monitoring-groups.page-2 {\r\n    grid-template-columns: 1fr 2fr !important;\r\n    grid-template-rows: 1fr;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .monitoring-groups.page-3 {\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n    grid-template-rows: 1fr;\r\n  }\r\n\r\n  .monitoring-groups.page-4 {\r\n    grid-template-columns: 2fr 1fr !important;\r\n    grid-template-rows: 1fr;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .monitoring-groups.page-5 {\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-template-rows: 1fr;\r\n  }\r\n  \r\n  /* 8개 센서 2개: 세로 배치 */\r\n  .monitoring-groups:has(.group-8) {\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: repeat(2, 1fr);\r\n  }\r\n  \r\n  /* 6개 센서 2개: 좌우 배치 */\r\n  .monitoring-groups:has(.group-6):not(:has(.group-8)) {\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr;\r\n  }\r\n  \r\n  /* 4개 센서 2개: 좌우 배치 */\r\n  .monitoring-groups:has(.group-4) {\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr;\r\n  }\r\n  \r\n  /* 3개 센서 4개: 가로 배치 */\r\n  .monitoring-groups:has(.group-3) {\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-template-rows: 1fr;\r\n  }\r\n  \r\n  /* 1개 센서: 나머지 */\r\n  .monitoring-groups:has(.group-1):not(:has(.group-3, .group-4, .group-6, .group-8)) {\r\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n    grid-template-rows: repeat(auto-fit, 1fr);\r\n  }\r\n  \r\n  .monitoring-group {\r\n    background-color: #ffffff;\r\n    border-radius: 4px;\r\n    padding: 8px;\r\n    box-shadow: 0 1px 2px rgba(0,0,0,0.05);\r\n    border: 1px solid #ddd;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n    min-height: 120px;\r\n  }\r\n  \r\n  /* 8개 센서: 전체 화면 차지 */\r\n  .group-8 {\r\n    grid-column: span 1;\r\n    grid-row: span 1;\r\n  }\r\n  \r\n  /* 6개 센서: 전체 화면 차지 */\r\n  .group-6 {\r\n    grid-column: span 1;\r\n    grid-row: span 1;\r\n  }\r\n  \r\n  /* 4개 센서: 좌우 배치 */\r\n  .group-4 {\r\n    grid-column: span 1;\r\n    grid-row: span 1;\r\n  }\r\n  \r\n  /* 3개 센서: 세로 배치 */\r\n  .group-3 {\r\n    grid-column: span 1;\r\n    grid-row: span 1;\r\n  }\r\n  \r\n  /* 1개 센서 */\r\n  .group-1 {\r\n    grid-column: span 1;\r\n    grid-row: span 1;\r\n  }\r\n  \r\n  .group-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    margin-bottom: 6px;\r\n    padding-bottom: 4px;\r\n    border-bottom: 1px solid #007bff;\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .group-header h3 {\r\n    margin: 0;\r\n    color: #007bff;\r\n    font-size: 1.4em;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .group-count {\r\n    color: #666;\r\n    font-size: 1em;\r\n    background-color: #f5f5f5;\r\n    padding: 3px 8px;\r\n    border-radius: 12px;\r\n  }\r\n  \r\n  .monitoring-grid {\r\n    display: grid;\r\n    gap: 12px;\r\n    flex: 1;\r\n    align-content: stretch;\r\n    align-items: stretch;\r\n    overflow: hidden;\r\n    height: 100%;\r\n    padding: 8px;\r\n  }\r\n  \r\n  /* 8개: 8x1 (가로로 길게) */\r\n  .grid-8 {\r\n    grid-template-columns: repeat(8, 1fr);\r\n    grid-template-rows: 1fr;\r\n  }\r\n  \r\n  /* 6개: 3x2 */\r\n  .grid-6 {\r\n    grid-template-columns: repeat(3, 1fr);\r\n    grid-template-rows: repeat(2, 1fr);\r\n  }\r\n  \r\n  /* 4개: 2x2 (좌우 배치용) */\r\n  .grid-4 {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    grid-template-rows: repeat(2, 1fr);\r\n  }\r\n  \r\n  /* 3개: 1x3 (vertical 배치) */\r\n  .grid-3 {\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: repeat(3, 1fr);\r\n  }\r\n  \r\n  /* 1개: 1x1 */\r\n  .grid-1 {\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: 1fr;\r\n  }\r\n  \r\n  .monitoring-box {\r\n    border: 1px solid #ccc;\r\n    border-radius: 6px;\r\n    padding: 8px;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 60px;\r\n    width: 100%;\r\n    height: 100%;\r\n    margin: 2px;\r\n  }\r\n  \r\n  .monitoring-box.no-data {\r\n    background-color: #ccc;\r\n    color: #666;\r\n  }\r\n  \r\n  .monitoring-box.normal,\r\n  .monitoring-box.low-temp,\r\n  .monitoring-box.high-temp,\r\n  .monitoring-box.abnormal {\r\n    color: white;\r\n  }\r\n  \r\n  .monitoring-machine {\r\n    font-size: 16px;\r\n    margin-bottom: 6px;\r\n    line-height: 1.2;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    width: 100%;\r\n    font-weight: 700;\r\n    color: #2c3e50;\r\n    text-shadow: 0 1px 1px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  .monitoring-temp {\r\n    font-size: 28px;\r\n    margin-bottom: 6px;\r\n    font-weight: 800;\r\n    line-height: 1;\r\n    color: #2c3e50;\r\n    text-shadow: 0 1px 2px rgba(0,0,0,0.15);\r\n  }\r\n  \r\n  .monitoring-range {\r\n    font-size: 14px;\r\n    line-height: 1.1;\r\n    overflow: hidden;\r\n    text-align: center;\r\n    width: 100%;\r\n    font-weight: 600;\r\n    color: #34495e;\r\n    text-shadow: 0 1px 1px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  .monitoring-legend {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 15px;\r\n    font-size: 14px;\r\n    margin: 0;\r\n    padding: 3px 0;\r\n    flex-shrink: 0;\r\n    height: 20px;\r\n    align-items: center;\r\n    background-color: var(--background-color);\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .monitoring-container {\r\n      padding: 0 2px;\r\n    }\r\n    \r\n    .monitoring-groups {\r\n      grid-template-columns: 1fr !important;\r\n      grid-template-rows: 1fr !important;\r\n      height: calc(100vh - 160px);\r\n    }\r\n    \r\n    .monitoring-group {\r\n      padding: 4px;\r\n      grid-column: span 1 !important;\r\n      grid-row: span 1 !important;\r\n    }\r\n    \r\n    .monitoring-grid {\r\n      grid-template-columns: repeat(auto-fit, minmax(35px, 1fr)) !important;\r\n      gap: 2px;\r\n    }\r\n    \r\n    .monitoring-legend {\r\n      flex-wrap: wrap;\r\n      gap: 6px;\r\n      font-size: 11px;\r\n    }\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .monitoring-header {\r\n    background-color: #2d2d2d;\r\n    color: #ffffff;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .page-info {\r\n    background-color: #34495e;\r\n    color: #ecf0f1;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .header-left h2 {\r\n    color: #ecf0f1;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .last-update {\r\n    color: #bdc3c7;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .nav-button {\r\n    background-color: #4a5a6a;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .nav-button:hover {\r\n    background-color: #3a4a5a;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .interval-input {\r\n    background-color: #2d2d2d;\r\n    border-color: #555;\r\n    color: #fff;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .interval-label {\r\n    color: #bdc3c7;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .auto-button {\r\n    background-color: #4a5a6a;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .auto-button.active {\r\n    background-color: #3a6a4a;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .auto-button:hover {\r\n    background-color: #3a4a5a;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .refresh-button {\r\n    background-color: #4a5a6a;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .refresh-button:hover {\r\n    background-color: #3a4a5a;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .monitoring-group {\r\n    background-color: #2d2d2d;\r\n    border-color: #404040;\r\n    box-shadow: 0 1px 2px rgba(0,0,0,0.2);\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .monitoring-box {\r\n    background-color: #1a1a1a !important;\r\n    border-color: #555;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .monitoring-box.no-data {\r\n    background-color: #333 !important;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .monitoring-machine {\r\n    color: #ecf0f1;\r\n    text-shadow: 0 1px 1px rgba(0,0,0,0.3);\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .monitoring-temp {\r\n    color: #ecf0f1;\r\n    text-shadow: 0 1px 2px rgba(0,0,0,0.4);\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .monitoring-range {\r\n    color: #bdc3c7;\r\n    text-shadow: 0 1px 1px rgba(0,0,0,0.3);\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .group-header h3 {\r\n    color: #4b8bd4;\r\n  }\r\n  \r\n  [data-theme=\"dark\"] .group-count {\r\n    background-color: #404040;\r\n    color: #ccc;\r\n  }\r\n\r\n/* 뱃지 컨테이너 */\r\n.badge-container {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 8px;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* 공통 뱃지 스타일 */\r\n.count-badge,\r\n.inactive-badge {\r\n  display: inline-block;\r\n  padding: 12px 0;\r\n  border-radius: 15px;\r\n  font-size: 24px;\r\n  font-weight: 800;\r\n  text-align: center;\r\n  min-width: 80px;\r\n}\r\n\r\n/* 개수 뱃지 스타일 */\r\n.count-badge {\r\n  background: #725AC1;\r\n  color: white;\r\n  border: 1px solid #725AC1;\r\n}\r\n\r\n/* 비가동 뱃지 스타일 */\r\n.inactive-badge {\r\n  background: #e74c3c;\r\n  color: white;\r\n  border: 1px solid #c0392b;\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n  0% { opacity: 1; }\r\n  50% { opacity: 0.7; }\r\n  100% { opacity: 1; }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
